module.exports = function(done, value){
  return {value: value, done: !!done};
};


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/core-js/library/modules/_iter-step.js
 ** module id = 220
 ** module chunks = 1
 **/